import { InputType, TopCode } from "../../value/AppConst";
import IsValid from "../../value/IsValid";

/*

# 운송사가 아닌 경우의 운송결과 레포트 조회용 입력
input InputTransPlanResultReportAdd {
    dateFrom: String!
    dateTill: String!
	dcCd: String
    transTypeCd: String
    vehTypeId: String
    comId: String
    storeId: String
    vehPlates: String
}
    배차구분
차종
점포
운송사
차량

*/

// 직접적인 레코드 생성이 아니라, 주어진 인수로 운송실적 레포트를 조회하여 엑셀 파일을 만들 수 있는
// 원시데이터를 json형태로 만들어 S3에 저장하기 위한 입력값들임.
const commonDict = {
    dateFrom: {
        id: 'dateFrom', label: '시작일',
        type: InputType.date, required: true, toAdd: true, toEdit: true,
        check: (value) => {return IsValid.date(value)},
    },
    dateTill: {
        id: 'dateTill', label: '종료일',
        type: InputType.date, required: true, toAdd: true, toEdit: true,
        check: (value) => {return IsValid.date(value)},
    },
    transTypeCd : {
		id: 'transTypeCd', label: '배차구분', // WAVE1, WAVE2, WAVE3
		type: InputType.select, required: false, toAdd: true, toEdit: true,
	}, // varchar(10)
    vehTypeId : {
		id: 'vehTypeId', label: '차종',
		type: InputType.select, required: false, toAdd: true, toEdit: true,
        labelKey: 'vehTypeName',
	}, // varchar(10)
    storeId : {
        id: 'storeId', label: '점포',
        type: InputType.text, required: false, toAdd: true, toEdit: true,
        help: '10자 이내로 입력하세요.',
        getOptionLabel: (rec) => {
            return `[${rec.storeId}] ${rec.storeName}`;
        }
    },
    comId : {
		id: 'comId', label: '운송사',
		type: InputType.select, required: false, toAdd: true, toEdit: true,
        labelKey: 'comName',
	},
    vehPlates : {
		id: 'vehPlates', label: '차량',
		type: InputType.select, required: false, toAdd: true, toEdit: true,
        labelKey: 'vehPlates',
	}, // int(11)
};

const DurationDict = {
    dateFrom: {
        id: 'dateFrom', label: '시작일',
        type: InputType.date, required: true, toAdd: true, toEdit: true,
        check: (value) => {return IsValid.date(value)},
    },
    dateTill: {
        id: 'dateTill', label: '종료일',
        type: InputType.date, required: true, toAdd: true, toEdit: true,
        check: (value) => {return IsValid.date(value)},
    },
};

export const TransPlanResultReportDict = commonDict;
export const ArrivalOnTimeReportDict = commonDict;
export const DeliveryReportDict = commonDict;
export const TempBreakReportDict = DurationDict;
export const TsrResultReportDict = DurationDict;
export const StoreTransReportDict = DurationDict;

export const TransPlanReportDict = {
    timeFrom: {id: 'timeFrom', required: true, toAdd: true, toEdit: true, check: (value) => IsValid.datetime(value)},
    timeTill: {id: 'timeTill', required: true, toAdd: true, toEdit: true, check: (value) => IsValid.datetime(value)},
    reqStateFlag: {id: 'reqStateFlag', required: false, toAdd: true, toEdit: true, check: (value) => !Boolean(value) || [TopCode.ReqStateFlag.TsrNotIssued, TopCode.ReqStateFlag.TsrIssued].includes(value)},
};
